function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Model, SpraypaintBase, MiddlewareStack } from 'spraypaint/lib';
import { WritePayload } from 'spraypaint/lib/util/write-payload';
import "./spraypaintOverrides.js";
import parseCsrf from "../parseCsrf.js";

var _dec, _class, _class2, _temp;

var BaseResource = (
/**
 * TODO: send pr to make this an official api on the base class
 * https://github.com/graphiti-api/spraypaint.js/issues/79
 *
 * @class BaseResource
 * @extends {SpraypaintBase}
 */
_dec = Model(), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_SpraypaintBase) {
  _inherits(BaseResource, _SpraypaintBase);

  var _super = _createSuper(BaseResource);

  function BaseResource() {
    var _this;

    _classCallCheck(this, BaseResource);

    _this = _super.apply(this, arguments);

    _this.toJsonPayload = function (options) {
      return new WritePayload(_assertThisInitialized(_this), options === null || options === void 0 ? void 0 : options.with).asJSON();
    };

    return _this;
  }

  return _createClass(BaseResource);
}(SpraypaintBase), _class2.baseUrl = '', _temp)) || _class);
var middlewareStack = new MiddlewareStack();
middlewareStack.beforeFilters.push(function (_url, options) {
  var csrf = parseCsrf();

  if (options.headers) {
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
  }

  if (csrf && options.headers) {
    options.headers['X-CSRF-TOKEN'] = csrf;
  }
});
BaseResource.middlewareStack = middlewareStack;
export default BaseResource;